module.exports = __webpack_public_path__ + "img/olympic-basketball.191d4f02.png";